module.exports = __webpack_public_path__ + "39e1676b05888b184e748deade664e84.svg";